import { withNamespaces } from "react-i18next";
import { CardBody } from "reactstrap";

/**
 * Shared kanban column header.
 * Uses singular/plural Card label based on count (TPDD behavior).
 */
const ColumnHeader = ({ t, title, subtitle }) => {
    const count = parseInt(subtitle, 10);
    const cardsLabel = count > 1 ? "Cards" : "Card";

    return (
        <CardBody className="kanban-column-header">
            <h4 className="card-title">{t(title)}</h4>
            <p className="mb-1">{`${t(subtitle)} ${t(cardsLabel)}`}</p>
        </CardBody>
    );
};

export default withNamespaces()(ColumnHeader);
